module.exports = __webpack_public_path__ + "static/img/homeCcll.9d811f08.png";